import flotTemplate from './barFlotChart.html';

/** @ngInject */
export function barFlotChart() {
    return {
        scope: {
            flotService: '=',
            flotDataset: '=',
            flotOptions: '='
        },
        templateUrl: flotTemplate
    };
}
